export type TechCategory = {
  name: string;
  items: string[];
  /** Item to highlight in coral on the Technologies page. */
  featured?: string;
};

export const TECH: TechCategory[] = [
  { name: "Frontend", items: ["React", "Angular", "Vue", "HTML"] },
  { name: "Backend", items: ["Node.js", "Python", "Java", "Spring Boot", "PHP"] },
  { name: "Mobile", items: ["iOS", "Android", "React Native", "Flutter"], featured: "React Native" },
  { name: "Databases", items: ["MySQL", "MongoDB", "Postgres", "Firebase"] },
  { name: "DevOps & Cloud", items: ["AWS", "Google Cloud", "Microsoft Azure", "Fastlane", "CI/CD"] },
  { name: "Project Management", items: ["Jira", "Confluence", "Slack", "Teams"] },
  { name: "CMS", items: ["Shopify"] },
  { name: "Digital Marketing", items: ["Meta Ads", "Google Ads", "HubSpot", "Hootsuite", "Salesforce"] },
];

/** Two rows for the Home page marquee. `tone` picks the pill style. */
export type MarqueeTech = { name: string; tone?: "dark" | "primary" | "accent" };

export const TECH_MARQUEE: MarqueeTech[][] = [
  [
    { name: "React" },
    { name: "React Native", tone: "dark" },
    { name: "Angular" },
    { name: "Vue" },
    { name: "Node.js", tone: "primary" },
    { name: "Python" },
    { name: "Java" },
    { name: "Spring Boot" },
    { name: "Flutter", tone: "accent" },
    { name: "PHP" },
  ],
  [
    { name: "AWS" },
    { name: "Google Cloud" },
    { name: "Microsoft Azure", tone: "dark" },
    { name: "PostgreSQL" },
    { name: "MongoDB" },
    { name: "Firebase", tone: "primary" },
    { name: "MySQL" },
    { name: "Shopify" },
    { name: "HubSpot" },
    { name: "Jira" },
  ],
];

/** How we choose a stack — shown on the Technologies page. */
export const TECH_PRINCIPLES = [
  { title: "Your product first", text: "Requirements decide the stack — not trends, and not what we used last time." },
  { title: "Your team can own it", text: "Well-documented, widely used tools your developers can pick up and run." },
  { title: "Built to grow", text: "Choices that scale with your users, without a rewrite a year from now." },
];
